const H5PTrueFalse = (attempt) => {
	const answer = JSON.parse(attempt.h5p_response.answer) || [];
	if (!answer.length) {
		return '';
	}

	const areAnswersVisible = !!attempt.h5p_response.correct_answer;
	const correctAnswer = areAnswersVisible ? JSON.parse(attempt.h5p_response.correct_answer) : [];

	const generateAnswerHTML = (option) => {
		const isSelected = answer[0].answer === option;
		const isCorrect = answer[0].correct;
		const showCorrectIcon = areAnswersVisible && correctAnswer[0] === option;
		const icon = isSelected
			? `<i class="icon ${isCorrect ? 'correct' : 'incorrect'} pb-heroicons pb-heroicons-solid_${isCorrect ? 'check' : 'x-mark'}"></i>`
			: '';

		return `
            <div>
                <div class="user-answer">${icon}</div>
                <div class="answer">
                    <div class="box box-answer">
                        ${showCorrectIcon ? '<i class="icon pb-heroicons pb-heroicons-solid_check"></i>' : ''}
                        <span>${option.charAt(0).toUpperCase() + option.slice(1)}</span>
                    </div>
                </div>
            </div>
        `;
	};

	return `
        <div class="h5p-true-false h5p-multi-choice">
            <div class="heading">
                <div>User's Answer</div>
                <div>Answer</div>
            </div>
            <div class="body">
                ${generateAnswerHTML('true')}
                ${generateAnswerHTML('false')}
            </div>
            <div class="explanation">
                ${areAnswersVisible ? `
                    <div class="box correct-answer">
                        <i class="icon pb-heroicons pb-heroicons-solid_check"></i>
                        Correct Answer
                    </div>` : ''
	}
                <div class="box correct">
                    <i class="icon pb-heroicons pb-heroicons-solid_check"></i>
                    User's correct answer
                </div>
                <div class="box incorrect">
                    <i class="icon pb-heroicons pb-heroicons-solid_x-mark"></i>
                    User's incorrect answer
                </div>
            </div>
        </div>
    `;
};

export default H5PTrueFalse;
